<template>
  <div class="component-request-cash">
    <vue-modaltor
      :visible="isModal"
      @hide="hideModal"
      :default-width="'50%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'60%',992:'80%',768:'90%'}"
    >
      <div class="input-radio rtl text-right">
        <div class="md-radio">
          <input type="radio" id="cash" value="cash" name="pay_mode" v-model="pay_mode">
          <label for="cash" class="font-14">در خواست واریز به حساب</label>
        </div>
      </div>
      <div class="input-radio rtl text-right">
        <div class="md-radio">
          <input type="radio" id="wallet" value="wallet" name="pay_mode" v-model="pay_mode">
          <label for="wallet" class="font-14">درخواست واریز به کیف پول در سایت</label>
        </div>
      </div>
      <div class="text-center d-flex justify-content-center">
        <button
          @click="setAdjest"
          class="mt-1 font-14 bttn-fill bttn-md bttn-success"
          v-ripple
        >درخواست تسویه</button>
      </div>
    </vue-modaltor>
    <b-table stacked="lg" :fields="fieldsItems" :items="history" class="font-14 text-center">
      <template v-slot:cell(action)="row" >
        <div class="text-center d-flex justify-content-center" v-if="row.item.All_Earn_wallet">
          <button
            @click="openModal"
            class="mt-1 font-14 bttn-fill bttn-md bttn-success"
            v-ripple
          >درخواست تسویه</button>
        </div>
        <p v-else class="mb-0 px-3 py-2 badge badge-secondary">در حال حاضر خرید جدیدی انجام نشده</p>
      </template>
      <template  v-slot:cell(All_Earn_wallet)="row">
        <p class="mb-0" v-if="row.item.All_Earn_wallet">{{row.item.All_Earn_wallet | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(E_wallet)="row">
        <p class="mb-0">{{row.item.E_wallet | currency}}</p>
      </template>
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.Paid | currency}}</p>
      </template>
    </b-table>
    <b-table
      stacked="lg"
      :fields="adjustmentFieldsItems"
      :items="myAdjustment"
      class="font-14 text-center"
    >
      <template v-slot:cell(action)="row" >
        <div class="text-center d-flex justify-content-center">
          <button
            @click="openModal(row)"
            class="mt-1 font-14 bttn-fill bttn-md bttn-success"
            v-ripple
          >تسویه</button>
        </div>
      </template>
      <template v-slot:cell(date)="row" >{{row.item.date | date}}</template>
      <template v-slot:cell(deficits)="row" >
        <p class="mb-0" v-if="row.item.deficits">{{row.item.deficits | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(impure_earned)="row" >
        <p class="mb-0" v-if="row.item.impure_earned">{{row.item.impure_earned | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <!-- <template v-slot:cell(pay_amount)="row" >
        <p class="mb-0" v-if="row.item.pay_amount">{{row.item.pay_amount | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>-->
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.paid ? 'تسویه شده' : 'در حال بررسی' }}</p>
      </template>
      <template v-slot:cell(pay_amount)="row" >
        <p class="mb-0" v-if="row.item.pay_amount">{{row.item.pay_amount | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(pay_mode)="row" >
        <p class="mb-0">{{row.item.pay_mode =='cash' ? 'نقدی' : 'الکترونیک'}}</p>
      </template>
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.Paid | currency}}</p>
      </template>
    </b-table>
    <page-number :lengthList="lengthList" v-if="lengthList > 0" @callBack="getMyAdjustment"/>
  </div>
</template>

<script>
export default {
  name: 'component-request-cash',
  data() {
    return {
      pay_mode: 'wallet',
      isLoading: false,
      isInstructor: false,
      fieldsItems: [
        { key: 'Paid', label: 'کل درآمد دریافتی',sortable: true },
        { key: 'E_wallet', label: 'کیف پول الکترونیک',sortable: true },
        { key: 'All_Earn_wallet', label: 'در آمد تسویه نشده',sortable: true },
        { key: 'action', label: 'درخواست تسویه' }
      ],
      adjustmentFieldsItems: [
        { key: 'date', label: 'تاریخ',sortable: true },
        { key: 'deficits', label: 'کسورات' ,sortable: true},
        { key: 'deficits_percent', label: 'درصد کسورات' ,sortable: true},
        { key: 'impure_earned', label: 'در آمد ناخالص' ,sortable: true },
        { key: 'msgs', label: 'پیغام' },
        { key: 'paid', label: 'وضعیت',sortable: true },
        { key: 'pay_amount', label: 'مبلغ پرداختی' ,sortable: true},
        { key: 'pay_mode', label: 'نحوه تسویه' }
      ],
      myAdjustment: [],
      isModal: false,
      lengthList: 1
    }
  },
  computed: {
    level() {
      return this.$store.state.auth.level
    },
    history() {
      return this.$store.state.Daccounting.myHistory
    }
  },
  async mounted() {
    this.isInstructor = await this.checkAccess(false)
    this.getHistory()
    this.getMyAdjustment(1)
  },
  methods: {
    async getMyAdjustment(p) {
      try {
        this.isLoading = true
        let { data } = await axios.post('/adjustment/get', { page_num: p })
        this.isLoading = false
        if (data.state != 200) {
          return
        }
        this.lengthList = data.adjusts.length
        if (data.adjusts.length > 0) {
          this.myAdjustment = data.adjusts
        }
      } catch (error) {
        console.log(error)
      }
    },
    hideModal() {
      this.isModal = false
    },
    openModal() {
      this.isModal = true
    },
    getHistory() {
      this.$store.dispatch('Daccounting/getMyHistory')
    },
    async  setAdjest() {
      try {
        this.isLoading = true
        let { data } = await axios.post('/adjustment/set', {
          pay_mode: this.pay_mode
        })
        this.isLoading = false
        this.hideModal()
        this.getMyAdjustment(1)
        if (data.state != 200) {
          if (data.state == 403) {
            this.$root.showInfoMsg({
              message: 'درخواست شما در حال بررسی میباشد'
            })
          }
          return
        }
        this.$root.showInfoMsg({
          message: 'درخواست شما ارسال شد'
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard-component/my-payment/request-cash.vue